var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrapper",staticStyle:{"display":"none"}},[_c('div',{staticClass:"footer-section f-section-1"},[_c('p',{staticClass:"foot-p"},[_vm._v("Copyright © 2016-"+_vm._s(_vm.year)+" kiwi 开为科技版权所有")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }